import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition, MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription, take, finalize } from 'rxjs';
import { UniqueIdService } from '../../services/unique-id/unique-id.service';
import { UserService } from '../../services/user/user.service';
import { ValidationsService } from '../../services/validations/validations.service';
import { AlertComponent } from '../alert/alert.component';
import { LoadingService } from '../loading/loading.service';
import { TermoAceiteComponent } from '../termo-aceite/termo-aceite.component';
import { ModalController } from '@ionic/angular';


@Component({
  selector: 'app-redefinir-senha',
  templateUrl: './redefinir-senha.component.html',
  styleUrls: ['./redefinir-senha.component.scss']
})
export class RedefinirSenhaComponent implements OnInit {
  hide = true;
  hideCurrent = true;
  public id: string;
  subsctiptions: Subscription[] = [];
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  form: FormGroup;
  isValidCPF: boolean = false;
  isValidSenha: boolean = false;
  isValidConfirmacaoSenha: boolean = false;
  dialogOpen: boolean = false;
  token: string | null = null;
  showFeedback: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private uniqueIdService: UniqueIdService,
    private fb: FormBuilder,
    private userService: UserService,
    private loadingService: LoadingService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private validationsService: ValidationsService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private modalCtrl: ModalController

  ) {
    this.id = this.uniqueIdService.generateUniqueIdWithPrefix('cadastroPessoa');
    this.form = this.fb.group({
      senha:[null, [Validators.required, Validators.minLength(8), this.senhaValidator.bind(this), ]],
      confirmacaoSenha:[null, [Validators.required, Validators.minLength(8), this.senhaValidator.bind(this), ]]
  
    },
    { validators: this.matchPasswords.bind(this) });
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      this.token = params.get('token');
    });
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  acessar() {
    this.router.navigate(['/login']);
  }

  async onSubmit() {
    const form = this.form.value;
    this.loadingService.showLoading();
    this.userService.passwordRecover(form, this.token).pipe(
      take(1),
      finalize(() => {
        this.loadingService.hideLoading();
      })
    )
    .subscribe(
      (response) => {
        this.showFeedback = true;
      },
      (erro) => {
        if (erro.status !== 500 && erro.status) {
          this.openSnackBar(erro.error.message, 'error');
        }else {
          this.openSnackBar(
            'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
            'error'
          );
        }
      }
    )
  }

  async openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }

    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  goToHome() {
    this.router.navigate(['/']);
  }

  validateCPFInput(event: any) {
    const inputValue = event.target?.value;
    if (inputValue) {
      this.isValidCPF = this.validationsService.validarCPF(inputValue);
    }
  }

  validateSenha(event:any){
    const inputValue = event.target?.value;
    if (inputValue) {
      this.isValidSenha = this.validationsService.isValidPassword(inputValue);
    }
  }
  validateConfirmarSenha(event:any){
    const inputValue = event.target?.value;
    if (inputValue) {
      this.isValidConfirmacaoSenha = this.validationsService.isValidPassword(inputValue);
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(TermoAceiteComponent);
    this.dialogOpen = true;
    dialogRef.afterClosed().subscribe(result => {
      this.dialogOpen = false;
    });
  }

  senhaValidator(control: AbstractControl): ValidationErrors | null {
    const inputValue = control.value;
    if (inputValue && !this.validationsService.isValidPassword(inputValue)) {
      return { invalidSenha: true }; // Erro de validação
    }
    return null; // Nenhum erro
  }
  matchPasswords(control: AbstractControl): void | null {
    const senhaControl = control.get('senha');
    const confirmacaoSenhaControl = control.get('confirmacaoSenha');
  
    if (!senhaControl || !confirmacaoSenhaControl) {
      return null; // Caso os controles não existam, retorna null
    }
  
    const senha = senhaControl.value;
    const confirmacaoSenha = confirmacaoSenhaControl.value;
  
    if (senha && confirmacaoSenha && senha !== confirmacaoSenha) {
      // Adiciona o erro nos controles individuais, mantendo outros erros existentes
      confirmacaoSenhaControl.setErrors({ ...confirmacaoSenhaControl.errors, passwordsMismatch: true });
      senhaControl.setErrors({ ...senhaControl.errors, passwordsMismatch: true });
    } else {
      // Remove apenas o erro passwordsMismatch
      if (confirmacaoSenhaControl.errors) {
        delete confirmacaoSenhaControl.errors['passwordsMismatch'];
        if (Object.keys(confirmacaoSenhaControl.errors).length === 0) {
          confirmacaoSenhaControl.setErrors(null);
        }
      }
      if (senhaControl.errors) {
        delete senhaControl.errors['passwordsMismatch'];
        if (Object.keys(senhaControl.errors).length === 0) {
          senhaControl.setErrors(null);
        }
      }
    }
  
    return null;
  }
  
}
